export default __webpack_public_path__ + "static/media/ACRE.9c477070.png";